module.exports = "/assets/data/ebc81c17500eb69f83b1c10f87f301be-NE13.data.json";